import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ActionTooltipModule } from 'src/app/shared/directives/action-tooltip.module';
import { helperService } from 'src/app/utils/helper';
import { ContactsService } from './contacts.service';

@Component({
  selector: 'app-contacts-grid',
  standalone: true,
  imports: [CommonModule, TableModule, DialogModule, TooltipModule, ActionTooltipModule],
  templateUrl: './contacts-grid.component.html',
  styleUrls: ['./contacts-grid.component.scss'],
})
export class ContactsGridComponent {
  contacts: any[] = [];
  cols = [
    { field: 'organizationName', header: 'Organization' },
    { field: 'firstName', header: 'First Name' },
    { field: 'lastName', header: 'Last Name' },
    { field: 'email', header: 'Email' },
    { field: 'associatedProjectIds', header: 'Associated Project IDs' },
    { field: 'createdBy', header: 'Created By' },
    { field: 'createdOn', header: 'Created On' },
  ];
  loading = true;
  totalRecords = 0;
  lastTableLazyLoadEvent: any = null;
  selectedContact: any = null;
  contactDialog = false;

  constructor(
    private readonly contactsService: ContactsService,
    private readonly helperService: helperService,
    private readonly router: Router
  ) {}

  loadContacts(event?: any): void {
    const loadEvent = event || this.lastTableLazyLoadEvent || { first: 0, rows: 10 };
    this.lastTableLazyLoadEvent = loadEvent;
    const first = loadEvent.first || 0;
    const rows = loadEvent.rows || 10;
    const payload = {
      ...this.helperService.generateEventPayload(loadEvent),
      searchTerm: '',
    };

    this.loading = true;
    this.contactsService.getContacts(Math.floor(first / rows) + 1, rows, payload).subscribe({
      next: (response: any) => {
        this.contacts = response?.data || [];
        // this.contacts[0] = { ...this.contacts[0], associatedProjectIds: [3398,3396] };
        this.totalRecords = response?.customValues?.totalNumberOfRecords || 0;
        this.loading = false;
      },
      error: () => {
        this.contacts = [];
        this.totalRecords = 0;
        this.loading = false;
      },
    });
  }

  viewContact(contact: any): void {
    this.selectedContact = contact;
    this.contactDialog = true;
  }

  closeDialog(): void {
    this.contactDialog = false;
    this.selectedContact = null;
  }

  navigateToProject(projectId: number): void {
    this.router.navigate(['/projects'], {
      state: {
        filters: [
          {
            field: 'id',
            operator: 'equals',
            value: projectId.toString(),
          },
        ],
        fromScreen:"CONTACTS_GRID",
      },
    });
  }

  getContactDetails(): Array<{ label: string; value: string }> {
    if (!this.selectedContact) return [];

    return Object.entries(this.selectedContact).map(([key, value]) => ({
      label: key.replace(/([A-Z])/g, ' $1').replace(/^./, character => character.toUpperCase()),
      value: Array.isArray(value) || (value !== null && typeof value === 'object')
        ? JSON.stringify(value)
        : String(value ?? '-'),
    }));
  }

}
